import { HttpClient } from '@remodeling/base';
import {
  GetAgencyAgentsDetailRequest,
  GetAgencyAgentsDetailResponse,
  GetAgentDetailRequest,
  GetAgentDetailResponse,
  GetAgentsBadgesRequest,
  GetAgentsBadgesResponse,
  GetAgentsRequest,
  GetAgentsResponse,
} from '../../model/dto';

export class GetSearchAgentsBadgesGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAgentsBadgesRequest) {
    return await this.httpClient.request<GetAgentsBadgesResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/agents/badges`,
      body: req,
    });
  }
}

export class GetSearchAgentsGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAgentsRequest) {
    return await this.httpClient.request<GetAgentsResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/agents`,
      body: req,
    });
  }
}

export class GetAgentDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAgentDetailRequest) {
    return await this.httpClient.request<GetAgentDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/agents/${req.agentCode}`,
    });
  }
}

export class GetAgencyAgentsDetailGateway {
  constructor(readonly httpClient: HttpClient) {}

  async exec(req: GetAgencyAgentsDetailRequest) {
    return await this.httpClient.request<GetAgencyAgentsDetailResponse>({
      method: 'GET',
      url: `${process.env.NEXT_PUBLIC_BASE_API_URL}${process.env.NEXT_PUBLIC_GW_PATH_PREFIX}/shop-service/api/v1/agencies/${req.agencyCode}/agents`,
      body: {
        agencyType: req.agencyType,
      },
    });
  }
}
